export class TrueCentroidResultsModel {
    results;
    messages;
    constructor() { }
    deserialize(input) {
        Object.assign(this, input);
        return this;
    }
}
